module.exports = __webpack_public_path__ + "static/media/02.0402f10d.png";